import React from 'react';

import {Helmet} from 'views/module';

import DomainGuideListScene from 'views/scenes/domain_guide/list/DomainGuideList';

const DomainGuideList = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Domain Guides</title>
      </Helmet>
      <DomainGuideListScene />
    </>
  );
};

export default DomainGuideList;
